module.exports = __webpack_public_path__ + "img/ic_dropup_active.af01894b.svg";